<template>
    <div class="order-details-modal-container animation-open-modal" v-if="open">
        <header>
            <div class="header-container">
                <div class="header-container-left">
                    <div @click="backToOrderList">
                        <slot name="back-button" />
                    </div>
                    <h1>{{ `${orderData.orderNumber}/${orderData.operationNumber}` }}</h1>
                </div>
                <button @click="closeModal" :aria-label="$t('Close') || 'Fechar'">
                    <CloseIcon v-if="windowWidth > 425 && windowWidth < 768" />
                    <CloseIconSmall v-else />
                </button>
            </div>

            <div class="graph-buttons-resources">
                <button
                    type="button"
                    :class="['btn-graph-resources', currentTab === 'info' ? 'btn-active' : 'btn-disabled']"
                    @click="setTab('info')"
                >
                    {{ $t("Informations") }}
                </button>

                <button
                    type="button"
                    :class="['btn-graph-resources', currentTab === 'progress' ? 'btn-active' : 'btn-disabled']"
                    @click="setTab('progress')"
                >
                    {{ $t("Progress") }}
                </button>

                <button
                    type="button"
                    :class="['btn-graph-resources', currentTab === 'history' ? 'btn-active' : 'btn-disabled']"
                    @click="setTab('history')"
                >
                    {{ $t("ProductionProgress.History") }}
                </button>

                <button
                    type="button"
                    :class="['btn-graph-resources', currentTab === 'links' ? 'btn-active' : 'btn-disabled']"
                    @click="setTab('links')"
                >
                    {{ $t("Links") }}
                </button>

                <button
                    type="button"
                    :class="['btn-graph-resources', currentTab === 'attachments' ? 'btn-active' : 'btn-disabled']"
                    @click="setTab('attachments')"
                >
                    {{ $t("Attachments") }}
                </button>
            </div>
        </header>

        <main class="h-100 modal-main-content">
            <InfoTab v-if="currentTab === 'info'" :data="componentsProps.infoTab" />
            <ProgressTab v-if="currentTab === 'progress'" :data="componentsProps.progressTab" />
            <TabNote
                v-if="currentTab === 'history'"
                :list="listOperationProgress"
                :isMultipleOrders="isMultipleOrders"
                @deleteOperationProgress="handleAfterDeleteAppointment()"
            />
            <TabLinks v-show="currentTab === 'links'" :list.sync="linksList" />
            <TabAttachments
                v-if="currentTab === 'attachments'"
                :operation-id="orderData.id"
                :resource-id="$route.params.resource_id"
            />
        </main>
    </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { formatCurrencyWithoutSymbol } from "@/views/pages/operator/utils";

export default {
    name: "OrderDetailsModal",
    components: {
        CloseIcon: () => import("@/assets/images/icons/close-icon-1.svg"),
        CloseIconSmall: () => import("@/assets/images/icons/close-icon.svg"),
        TabAttachments: () =>
            import("@/views/pages/operator/components/TabAttachments/TabAttachments.vue"),
        TabLinks: () =>
            import("@/views/pages/operator/components/TabLinks/TabLinks.vue"),
        TabNote: () =>
            import("@/views/pages/operator/components/TabNote/TabNote.vue"),
        InfoTab: () =>
            import("@/views/pages/operator/components/DetailsModal/components/InfoTab"),
        ProgressTab: () =>
            import("@/views/pages/operator/components/DetailsModal/components/ProgressTab")
    },
    props: {
        orderData: {
            type: Object,
            default: () => ({}),
            required: true
        },
        open: {
            type: Boolean,
            default: false
        },
        isMultipleOrders: {
            type: Boolean,
            default: false
        },
        initialTab: {
            type: String,
            default: "info"
        },
        statusList: {
            type: Array,
            default: () => []
        },
        peopleList: {
            type: Array,
            default: () => []
        },
        shiftList: {
            type: Array,
            default: () => []
        },
        showAttachmentsProp: {
            type: Boolean,
            default: false
        },
        showLinksProp: {
            type: Boolean,
            default: false
        }
    },
    data() {
        let defaultTab = "info";
        if (this.initialTab) {
            defaultTab = this.initialTab;
        } else if (this.showLinksProp) {
            defaultTab = "links";
        } else if (this.showAttachmentsProp) {
            defaultTab = "attachments";
        }

        return {
            windowWidth: window.innerWidth,
            currentTab: defaultTab,
            hasDeletedAppointment: false,
            componentsProps: {
                infoTab: {},
                progressTab: {},
                linksTab: {},
                noteTabs: {}
            },
            currentSite: this.$cookies.get("userInfo")?.currentSite,
            linksList: [],
            listOperationProgress: []
        };
    },
    watch: {
        initialTab(newTab) {
            if (newTab) this.setTab(newTab);
        },
        showLinksProp(val) {
            if (val) this.setTab("links");
        },
        showAttachmentsProp(val) {
            if (val) this.setTab("attachments");
        },
        orderData: {
            deep: true,
            handler() {
                this.formatPropsInfoTab();
                this.formatPropsProgressTab();
                this.getLinks();
                this.getOperationProgress();
            }
        }
    },
    mounted() {
        if (this.open) this.addOpenAnimation();

        this.formatPropsInfoTab();
        this.formatPropsProgressTab();
        this.getLinks();
        this.getOperationProgress();

        $(function () {
            const slider = document.querySelector(".graph-buttons-resources");
            if (!slider) return;
            let mouseDown = false;
            let startX, scrollLeft;

            let startDragging = function (e) {
                mouseDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            };
            let stopDragging = function () {
                mouseDown = false;
            };

            slider.addEventListener("mousemove", (e) => {
                e.preventDefault();
                if (!mouseDown) {
                    return;
                }
                const x = e.pageX - slider.offsetLeft;
                const scroll = x - startX;
                slider.scrollLeft = scrollLeft - scroll;
            });

            slider.addEventListener("mousedown", startDragging, false);
            slider.addEventListener("mouseup", stopDragging, false);
            slider.addEventListener("mouseleave", stopDragging, false);
        });
    },
    methods: {
        ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
        ...mapActions("app", ["removeRequestLoading"]),
        setTab(tab) {
            this.currentTab = tab;
            if (tab === "history") {
                this.getOperationProgress();
            }
        },
        handleAfterDeleteAppointment() {
            this.getOperationProgress();

            if (this.$router.currentRoute.params?.appointment_type == 1) {
                this.hasDeletedAppointment = true;
            }
            this.$emit("deleteOperationProgress");
        },
        addOpenAnimation() {
            const modal = document.querySelector(".order-details-modal-container");
            if (!modal) return;
            modal.classList.add("animation-open-modal");

            setTimeout(
                () => {
                    const el = document.querySelector(".order-details-modal-container");
                    if (el) el.classList.remove("animation-open-modal");
                },
                1000
            );
        },
        closeAnimation() {
            const modal = document.querySelector(".order-details-modal-container");
            if (!modal) return;
            modal.classList.add("animation-close-modal");
            modal.classList.add("closed-modal");

            setTimeout(() => this.$emit("close", false), 500);
        },
        closeModal() {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            this.closeAnimation();
            this.$emit("closeListModal");

            this.$router.currentRoute.params?.appointment_type == 1 &&
                this.checkHasReworkAppointments();
        },
        checkHasReworkAppointments() {
            const { params } = this.$router.currentRoute;
            const hasReworkAppointment = this.listOperationProgress.find(
                (appointment) => appointment.is_rework == 1
            );

            if (this.hasDeletedAppointment && !hasReworkAppointment)
                setTimeout(() => {
                    this.$router.push({
                        name: "operator-production-progress",
                        params: {
                            ...params,
                            appointment_type: 0
                        }
                    });
                    this.$router.go();
                }, 500);
        },
        backToOrderList() {
            this.closeAnimation();
        },
        formatFloatStringForInt(value) {
            if (value === null || value === undefined || isNaN(value)) return "0";
            return parseFloat(value).toFixed();
        },
        formatPercentStringForIntNumber(value) {
            if (!value || isNaN(value)) return 0;
            const percent = 100;
            return Number((parseFloat(value) * percent).toFixed());
        },
        formatPercentStringForFloatNumber(value) {
            if (!value || isNaN(value)) return "0.00";
            const percent = 100;
            return (Number(value) * percent).toFixed(2);
        },
        formatHour(value) {
            if (value === null || value === undefined || isNaN(value)) return "0,00";
            return parseFloat(value).toFixed(2).replace(".", ",");
        },
        formatHourAndMinute(value) {
            if (value === null || value === undefined || isNaN(value)) return "0 h 00 m";
            let number = Number(value);
            let sign = number >= 0 ? 1 : -1;
            number = number * sign;

            const hour = Math.floor(number);
            let decpart = number - hour;

            const min = 1 / 60;
            decpart = min * Math.round(decpart / min);

            let minute = Math.floor(decpart * 60) + "";
            minute = minute.length < 2 ? "0" + minute : minute;
            sign = sign == 1 ? "" : "-";

            return `${sign}${hour} h ${minute} m`;
        },
        formatPropsInfoTab() {
            const { orderData } = this;
            const observation = orderData.note;

            this.componentsProps.infoTab = {
                Order: {
                    Quantity: {
                        value: formatCurrencyWithoutSymbol(orderData.plannedQuantity),
                        truncate: false
                    },
                    Priority: {
                        value: this.formatFloatStringForInt(orderData.priority),
                        truncate: false
                    },
                    DueDate: {
                        value: orderData.dueDate,
                        truncate: false
                    }
                },
                Operation: {
                    OperationNo: {
                        value: orderData.operationNumber,
                        truncate: false
                    },
                    OperationName: {
                        value: orderData.operationName,
                        truncate: true
                    },
                    ProductName: {
                        value: orderData.product,
                        truncate: true
                    },
                    Resource: {
                        value: orderData.resources,
                        truncate: true
                    },
                    Workcenter: {
                        value: orderData.workcenter,
                        truncate: true
                    },
                    ProductCode: {
                        value: orderData.productCode,
                        truncate: true
                    },
                    ForecastOperationSetup: {
                        value: orderData.setupStart,
                        truncate: false
                    },
                    ForecastOperationStart: {
                        value: orderData.startTime,
                        truncate: false
                    },
                    ForecastOperationEnd: {
                        value: orderData.endTime,
                        truncate: false
                    }
                },
                Attributes: orderData.attributes,
                Observations: observation ? observation : "-"
            };
        },
        formatPropsProgressTab() {
            const { orderData } = this;

            const setProgressInfoData = () => ({
                quantity: {
                    planned: this.formatFloatStringForInt(orderData.plannedQuantity),
                    produced: this.formatFloatStringForInt(orderData.producedQuantity),
                    rework: this.formatFloatStringForInt(orderData.reworkQuantity),
                    scrap: this.formatFloatStringForInt(orderData.refuseQuantity)
                }
            });

            this.componentsProps.progressTab = {
                progressData: {
                    theoretical_progress: this.formatPercentStringForIntNumber(orderData.theoricalProgress),
                    real_progress: this.formatPercentStringForIntNumber(orderData.realProgress)
                },
                progressInfoData: setProgressInfoData(),
                statusData: orderData.statusData
            };
        },
        async getLinks() {
            try {
                const { data } = await this.$http2.get(
                    `/api/mysfc/operations/${this.orderData.id}/attachments`,
                    {
                        params: { resourceId: this.$route.params.resource_id || undefined },
                        headers: { ignoredRequest: true }
                    }
                );
                this.linksList = (data.data || []).map((file) => ({
                    ...file,
                    type: file.fileType
                }));
            } catch (error) {
                console.error("Error fetching links:", error);
                this.linksList = [];
            }
        },
        async getOperationProgress() {
            const GET_OPERATION_PROGRESS_URL = `/api/mysfc/operator/operation-progress?operationId=${this.orderData.id}&siteId=${this.currentSite}`;
            this.UPDATE_FLAG_SHOW_OVERLAY(true);

            try {
                const response = await this.$http2.get(GET_OPERATION_PROGRESS_URL);
                this.listOperationProgress = response?.data?.data || [];
                this.removeRequestLoading();
            } catch (error) {
                console.error("Error fetching operation progress:", error);
                this.listOperationProgress = [];
            } finally {
                this.removeRequestLoading();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.header-container {
    display: flex;
    align-items: center;
    padding: 16px 29px 15px;
    gap: 10px;
    background: #ffffff;
    border-bottom: 1px solid #cfc4be;
    justify-content: space-between;

    .header-container-left {
        display: flex;
        align-items: center;
    }

    h1 {
        margin: 0;
        font-weight: 600;
        font-size: 26px;
        line-height: 36px;
        color: #4c4541;
    }

    button {
        padding: 8px;
        border: none;
        background: none;
        cursor: pointer;
        min-width: 44px;
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        transition: background-color 0.2s ease;
        &:hover {
            background-color: #f2eee9;
        }
    }
}

.graph-buttons-resources {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    height: 62px;
    overflow-x: auto;
    position: relative;
    z-index: 10;
    background: #ffffff;
    box-shadow:
        0px 3px 4px rgba(0, 0, 0, 0.14),
        0px 3px 3px rgba(0, 0, 0, 0.12),
        0px 1px 8px rgba(0, 0, 0, 0);

    &::-webkit-scrollbar {
        display: none !important;
    }

    .btn-graph-resources {
        font-size: 17px;
        border: none;
        padding: 0 28px;
        cursor: pointer;
        white-space: nowrap;
    }

    .btn-active {
        width: 100%;
        background-color: transparent;
        font-weight: 700;
        font-size: 17px;
        line-height: 26px;
        color: #974900;
        box-shadow: inset 0px -4px 0px #974900;
        min-width: 160px;
    }

    .btn-disabled {
        width: 100%;
        background-color: transparent;
        font-weight: 600;
        font-size: 17px;
        line-height: 26px;
        color: #7d726b;
        border-bottom: 1px solid #cfc4be;
        min-width: 160px;
    }
}

.order-details-modal-container {
    height: 100dvh;
    width: 100vw;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9991;
    display: flex;
    flex-direction: column;

    main {
        overflow: auto;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-track {
            background: #fff;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #cfc4be;
            border-radius: 9px;
        }
    }

    &.animation-open-modal {
        animation: openModal 0.5s normal;

        @keyframes openModal {
            0% {
                top: 100vh;
            }

            100% {
                top: 0;
            }
        }
    }

    &.animation-close-modal {
        animation: closeModal 0.5s normal;

        @keyframes closeModal {
            0% {
                top: 0;
            }

            100% {
                top: 100vh;
            }
        }
    }

    &.closed-modal {
        top: 100vh;
    }

    .modal-main-content {
        flex: 1;
        overflow-y: auto;
    }
}

.container-components {
    padding: 24px 29px;
}

@media (max-width: 768px) {
    .header-container {
        h1 {
            font-size: 36px;
            line-height: 50px;
        }
    }

    .graph-buttons-resources {
        .btn-active {
            font-size: 18px;
        }
    }
}

@media (max-width: 425px) {
    .header-container {
        padding: 15px 16px 14px;

        h1 {
            font-size: 18px;
            line-height: 26px !important;
        }
    }

    .graph-buttons-resources {
        .btn-active {
            font-size: 16px;
        }

        .btn-disabled {
            font-size: 16px;
        }
    }

    .container-components {
        padding: 24px 16px;
    }
}
</style>
